import { type ConfigurableView, type ViewField } from '@air/api/types';

import { isViewFieldSortField, isViewFieldVisibilityField } from '~/swr-hooks/gallery/viewFields/types';

/**
 * This method filter out any fields from saved config views that do not appear in existingViewFields
 */
export const filterOutMissingViewFields = ({
  existingViewFields,
  configView,
}: {
  existingViewFields: ViewField[];
  configView: ConfigurableView | undefined;
}): ConfigurableView | undefined => {
  if (!configView) {
    return undefined;
  }

  const configViewCustomFields = new Map<string, ViewField>();
  const configViewCommonFields = new Map<string, ViewField>();

  existingViewFields.forEach((option) => {
    if (option.customFieldId) {
      configViewCustomFields.set(option.customFieldId, option);
    } else {
      configViewCommonFields.set(option.name, option);
    }
  });

  const visibleFields = configView.visibleFields.filter((field) => {
    if (field.customFieldId) {
      const existingCustomField = configViewCustomFields.get(field.customFieldId);
      return !!existingCustomField && isViewFieldVisibilityField(existingCustomField);
    } else if (field.name) {
      const existingCommonField = configViewCommonFields.get(field.name);
      return !!existingCommonField && isViewFieldVisibilityField(existingCommonField);
    }
    return true;
  });

  const sortFields = configView.sortFields.filter((field) => {
    if (field.customFieldId) {
      const existingCustomField = configViewCustomFields.get(field.customFieldId);
      return !!existingCustomField && isViewFieldSortField(existingCustomField);
    } else if (field.name) {
      const existingCommonField = configViewCommonFields.get(field.name);
      return !!existingCommonField && isViewFieldSortField(existingCommonField);
    }
    return true;
  });

  return {
    ...configView,
    visibleFields,
    sortFields,
  };
};
